import React from "react";

const ViewDiffButton = ({ repoUrl, mainHash, fixHash }) => {
  const handleClick = () => {
    const url = new URL(`${repoUrl}/compare/${mainHash}..${fixHash}`);
    url.searchParams.set("diff", "split");
    window.open(url);
  };
  return (
    <button class="issue" onClick={handleClick}>
      View Fix on GitHub
    </button>
  );
};
export default ViewDiffButton;
